import { TechLogAttachment } from '.';
import { date, dateTime } from '..';

type gpuTime = string;

type preflightCustomData = any;
type postflightCustomData = any;
type cycles = any;

export enum TechlogFlightStatus {
  COMPLETE = 'complete',
  PLANNED = 'planned',
}

export interface TechLogSector {
  id: string;
  tripId: string;
  preflightSignatureId: string;
  postflightSignatureId: string;
  departureAirportId: number;
  arrivalAirportId: number;
  actualArrivalAirportId: number;
  pilotInCommandId: string;
  secondInCommandId: string;
  pilotPerformingTakeoffId: string;
  pilotPerformingLandingId: string;
  userId: string;
  apuSeconds: number;
  apuReading: number;
  apuCyclesReading: number;
  hobbsDeparture: number;
  hobbsArrival: number;
  offblocksTime: dateTime;
  takeoffTime: dateTime;
  landingTime: dateTime;
  onblocksTime: dateTime;
  landingsCount: number;
  takeoffsCount: number;
  status: TechlogFlightStatus;
  flightType: string;
  remarks: string;
  createdAt: dateTime;
  updatedAt: dateTime;
  date: date;
  source: string;

  preflightCustomData: preflightCustomData;
  postflightCustomData: postflightCustomData;
  cycles: cycles;
  passengersMale: number;
  passengersFemale: number;
  passengersChildren: number;
  passengersInfants: number;
  baggageWeight: number;
  gpuStart: gpuTime;
  gpuEnd: gpuTime;
  gpuSeconds: number;
  maxFlightLevel: number;
  pressurisedCycle: boolean;
  preflightMxCheckIds: Array<string>;
  abandonmentReason: string;
  attachments: Array<TechLogAttachment>;
  plannedFuelBurn?: number;
  actualFuelBurn?: number;
  fuelBurnJustification?: string;

  // "cycles": {
  //   "airframe": 1,
  //   "engine1": 1,
  //   "engine2": 1,
  //   "engine3": 1,
  //   "engine4": 1,
  //   "apu": 1,
  //   "pressure": 1
  // },

  // "passengersMale": 1,
  // "passengersFemale": 1,
  // "passengersChildren": 1,
  // "passengersInfants": 1,
  // "baggageWeight": 1,
  // "gpuStart": "00:00:00",
  // "gpuEnd": "00:00:00",
  // "gpuSeconds": 1,
  // "maxFlightLevel": 1,
  // "pressurisedCycle": true,
  // "preflightMxCheckIds": [
  //   "01610b42-5e89-4eb4-a17f-c20e7f772676"
  // ],
  // "abandonmentReason": "technicalFailure",
  // "attachments": [
}

export interface TechLogSectorv2 extends TechLogSector {
  pilotFlyingId: string;
  pilotMonitoringId: string;
}

// "id": "01610b42-5e89-4eb4-a17f-c20e7f772676",
// "tripId": "01610b42-5e89-4eb4-a17f-c20e7f772676",
// "preflightSignatureId": "01610b42-5e89-4eb4-a17f-c20e7f772676",
// "postflightSignatureId": "01610b42-5e89-4eb4-a17f-c20e7f772676",
// "departureAirportId": 1,
// "arrivalAirportId": 2,
// "actualArrivalAirportId": 3,
// "pilotInCommandId": "01610b42-5e89-4eb4-a17f-c20e7f772676",
// "secondInCommandId": "01610b42-5e89-4eb4-a17f-c20e7f772676",
// "userId": "01610b42-5e89-4eb4-a17f-c20e7f772676",
// "apuSeconds": 1,
// "apuReading": 1,
// "apuCyclesReading": 1,
// "hobbsDeparture": 1.5,
// "hobbsArrival": 2.5,
// "offblocksTime": {},
// "takeoffTime": {},
// "landingTime": {},
// "onblocksTime": {},

// "landingsCount": 1,
// "takeoffsCount": 1,
// "status": "partial",
// "flightType": "training",
// "remarks": "hi",
// "createdAt": {},
// "updatedAt": {},
// "date": {},
// "source": "techlogApp",

// "preflightCustomData": {
//   "trendMonitoring": {
//     "justifications": {
//       "2022-03-08T16:42:38.907+0000": {
//         "trendMonitoring": "test"
//       }
//     }
//   }
// },
// "postflightCustomData": {
//   "trendMonitoring": {
//     "justifications": {
//       "2022-03-08T16:42:38.907+0000": {
//         "trendMonitoring": "test"
//       }
//     }
//   }
// },
export type TechlogSyncSectorInput = {
  id?: string;
  originId?: string;
  leonFlightId?: number;
} & TechlogSectorCreateInput;

/**
 * Sector shape used at the sync-flow boundary (`syncTechlogTripsAndSectors`
 * activity input + the entries inside `syncTechlogTripsAndSectorsExceptions`).
 * Extends the canonical `TechlogSyncSectorInput` with workflow-attached carry
 * fields used to make per-flight sync decisions. None of these fields are
 * sent to the TechLog API — they exist only between the integration workflow
 * and the activity that performs the sync.
 *
 * - `aircraft`: source-system aircraft for this flight, surfaced per-sector
 *   by `buildTechlogFlightsAndTripFromStandardizedFlights` via the
 *   `aircraft: 'aircraft'` entry in `TechlogSectorMapping`. Used by the
 *   cross-aircraft pre-check.
 * - `syncedDocId` / `syncedRegistration`: prior Firestore sync record
 *   reference, attached by integration workflows after a lookup via
 *   `fetchSyncedInformationByFlightIds`. Used by the cross-aircraft
 *   pre-check (against `aircraft`) and by
 *   `syncAndStoreTechlogSectorsAndTrips` to choose between
 *   `updateSyncedInformation` and `reparentSyncedInformation`.
 */
export type TechlogSyncSectorInputWithSyncMetadata = TechlogSyncSectorInput & {
  aircraft?: string;
  syncedDocId?: string;
  syncedRegistration?: string;
};

export interface TechlogSectorCreateInput {
  tripId: string;
  departureAirportId: number;
  arrivalAirportId: number;
  actualArrivalAirportId?: number;
  pilotInCommandId?: string;
  secondInCommandId?: string;
  userId?: string;
  apuSeconds?: number;
  apuReading?: number;
  apuCyclesReading?: number;
  hobbsDeparture?: number;
  hobbsArrival?: number;
  offblocksTime?: dateTime;
  takeoffTime: dateTime;
  landingTime: dateTime;
  onblocksTime?: dateTime;
  landingsCount?: number;
  preflightCustomData?: preflightCustomData;
  flightType?: string;
  flightId?: string;
}

type TimeData = {
  Type: string;
  DateTime: date;
};

export interface NavblueFlightDataInput {
  FlightNumber?: string;
  UniqueId?: string;
  Times?: {
    Time: TimeData[];
  };
  Airports?: {
    DepartureAirport: {
      ICAO: string;
    };
    ArrivalAirport: {
      ICAO: string;
    };
  };
  VoyageReport?: {
    ArrivalPilot: string;
  };
}

/*
    "fluidUplifts": [
      {
        "fluidType": "hydraulic",
        "fluidDestination": "engine",
        "fluidDestinationNumber": 1,
        "upliftUnit": "ml",
        "adjustment": 0.5,
        "recordOwnerId": "21610b42-5e89-4eb4-c28b-a111aaabbbcc",
        "recordOwnerType": "Aircraft",
        "initialValue": 100,
        "uplift": 100,
        "departureValue": 100,
        "hydraulicCircuitId": "21610b42-5e89-4eb4-c28b-a111aaabbbcc",
        "category": "preflight"
      }
    ],
    "fuelUplifts": [
      {
        "aircraft_value_pre_uplift": 1.5,
        "aircraft_value_post_event": 1.5,
        "aircraft_planned_uplift": 1.5,
        "aircraft_actual_uplift": 1.5,
        "truck_actual_uplift": 1.5,
        "truck_unit": "kg",
        "density": 0.8
      }
    ],
    "deiceEvents": [
      {
        "startTime": {},
        "endTime": {},
        "fluidRatioLeft": 50,
        "fluidRatioRight": 50,
        "quantity": 100,
        "fluidType": "I",
        "holdoverSeconds": 100,
        "holdoverTime": 100
      }
    ]
    //*/
